export default __webpack_public_path__ + "static/media/Roboto-Bold.acc81739.ttf";